import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WhatsappService {
  private readonly baseNumber = environment.whatsappNumber;

  buildLink(message: string, number: string = this.baseNumber): string {
    const encoded = encodeURIComponent(message);
    return `https://wa.me/${number}?text=${encoded}`;
  }

  applyLink(vacanteTitulo: string, empresaNombre: string, number?: string, vacanteId?: string): string {
    // CHAMBIA-20 (P3): token estricto [chambia-aplicar:{vacanteId}] que el bot
    // de WhatsApp detecta antes de la máquina de estados para registrar la
    // postulación sin depender del flujo de matches (flow:lastmatches).
    const token = vacanteId ? ` [chambia-aplicar:${vacanteId}]` : '';
    const message = `Hola, quiero postularme a la vacante "${vacanteTitulo}" de ${empresaNombre} que vi en Chambia.${token}`;
    return this.buildLink(message, number);
  }

  registerLink(): string {
    return this.buildLink('Hola, quiero registrarme en Chambia para buscar chamba.');
  }

  demoLink(): string {
    return this.buildLink(
      'Hola, mi empresa quiere solicitar una demo de Chambia para reclutar con IA.'
    );
  }
}
